const mobileBrands = [
  { label: 'Apple', value: 'Apple' },
  { label: 'Redmi', value: 'Xiaomi' },
  { label: 'Oppo', value: 'Oppo' },
  { label: 'Samsung', value: 'Samsung' },
];

const laptopBrands = [
  { label: 'HP', value: 'HP' },
  { label: 'Dell', value: 'Dell' },
  { label: 'Lenovo', value: 'Lenovo' },
];

const categories = [
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Laptop', value: 'Laptop' },
];

const customerRatings = [
  { label: '4 & above', value: '4' },
  { label: '3 & above', value: '3' },
  { label: '2 & above', value: '2' },
  { label: '1 & above', value: '1' },
];

const discounts = [
  { label: '10% or more', value: '10' },
  { label: '20% or more', value: '20' },
  { label: '30% or more', value: '30' },
];

const availabilityOptions = [
  { label: 'Available', value: 'yes' },
  { label: 'Include out of stock', value: 'no' },
];

const sortOptions = [
  { label: 'Price: High to Low', value: 'priceHighToLow' },
  { label: 'Price: Low to High', value: 'priceLowToHigh' },
  { label: 'Rating: High to Low', value: 'ratingHighToLow' },
  { label: 'Rating: Low to High', value: 'ratingLowToHigh' },
];

export {
  mobileBrands,
  laptopBrands,
  categories,
  discounts,
  customerRatings,
  availabilityOptions,
  sortOptions,
};
